//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'ProductCount',
  props: {
    count: {
      type: Number,

      default() {
        return 0;
      }

    }
  },
  computed: {
    result() {
      return "".concat(this.count, " ").concat(this.$i18n.tc('product', this.count));
    }

  }
};